import { Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminOverview from "@/pages/AdminOverview";
import AdminUpload from "@/pages/AdminUpload";
import AdminUploadMTech from "@/pages/AdminUploadMTech";
import AdminFiles from "@/pages/AdminFiles";
import AdminStudents from "@/pages/AdminStudents";
import RemarksReport from "@/pages/RemarksReport";
import DobUpload from "@/pages/DobUpload";
import FinalAwardsUpload from "@/pages/Admin/FinalAwardsUpload";
import StudentLogin from "@/pages/StudentLogin";
import StudentResults from "@/pages/StudentResults";
import Verify from "@/pages/Verify";
import PublishResults from "@/pages/PublishResults";

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminOverview />} />
          <Route path="upload" element={<AdminUpload />} />
          <Route path="upload-mtech" element={<AdminUploadMTech />} />
          <Route path="files" element={<AdminFiles />} />
          <Route path="remarks" element={<RemarksReport />} />            
          <Route path="dobs" element={<DobUpload />} />
          <Route path="final-awards" element={<FinalAwardsUpload />} />
          <Route path="students" element={<AdminStudents />} />
          <Route path="publish" element={<PublishResults />} />
        </Route>
        <Route path="/student" element={<StudentLogin />} />
        <Route path="/student/results" element={<StudentResults />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
